import {Observable, of, throwError} from "rxjs";
import {delay, mergeMap, retryWhen} from "rxjs/operators";
import {Log, LogTag} from "../services/Log";

export function retryWithBackoff<U>(delayMs: number = 2000, maxRetry = 4): any {
    return <T>(src: Observable<T>): Observable<any> => {
        let retries = maxRetry;
        return src.pipe(
            retryWhen((errors: Observable<any>) => errors.pipe(
                mergeMap(error => {
                    if (error.code == 'cors') {
                      console.error(`retryWithBackoff CORS url: ${error.url}`);
                      return throwError(`CORS`);
                    } else if (error.code == '404') {  // page not found
                      Log.w(this, LogTag.CACHE, "Error: 404");
                      return throwError('Error 404 ' + error.url);
                    } else {
                      if (retries-- > 0) {
                        Log.w(this, LogTag.CACHE, `retry: ${(maxRetry - retries)}, url: ${error.url}`);
                        const backoffTime = delayMs * Math.pow(2, (maxRetry - retries));
                        return of(error).pipe(delay(backoffTime));
                      }
                      return throwError({ message: `retryWithBackoff exceeded: max: ${maxRetry}, url: ${error.url}` });
                    }
                  }
                )
            ))
        );
    };
}


